// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3780df09","510":"a6fe6adb","966":"e337e3c1"}[chunkId] + ".chunk.js";
};